import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCheck2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 82,
	height: 114,
	fill: "none",
	viewBox: "0 0 82 114",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		stroke: "#00ABFF",
		strokeWidth: .75,
		d: "M79.272 1H2.728c-.476 0-.91.194-1.221.507C1.194 1.82 1 2.252 1 2.73v108.54c0 .477.194.91.507 1.223.312.313.743.507 1.221.507h76.544c.476 0 .91-.194 1.221-.507.314-.313.507-.746.507-1.223V2.73c0-.477-.194-.91-.507-1.223-.312-.313-.745-.507-1.221-.507z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#00ABFF",
		stroke: "#00ABFF",
		d: "M5.31 20.507h7.773v9.88H5.31v-9.88zm10.966 0h7.773v.087h-7.773v-.087zm0 3.263h18.74v.088h-18.74v-.088zm30.706-3.263h7.774v9.88h-7.774v-9.88zm10.966 0h7.773v.087h-7.773v-.087zm0 3.263h18.74v.088h-18.74v-.088z"
	})]
});
export default SvgCheck2;
